import { Step } from "react-joyride";
import {
  MAP_ADDRESS_STEP,
  MAP_CHANGE_ADDRESS_STEP,
  MAP_CONFIRM_STEP,
  MAP_OVERWRITE_ADDRESS_STEP,
  MAP_PIN_STEP,
} from "./draftTourContent";

const stageMapModalTourSteps: Step[] = [
  {
    ...MAP_ADDRESS_STEP,
    buttons: ["close"],
    overlayClickAction: false,
    dismissKeyAction: false,
  },
  MAP_PIN_STEP,
  MAP_CHANGE_ADDRESS_STEP,
  MAP_OVERWRITE_ADDRESS_STEP,
  MAP_CONFIRM_STEP,
];

export default stageMapModalTourSteps;
